export default __webpack_public_path__ + "static/media/SimpleBarChart.10830071.svg";